import { render } from "./DetallesCliente.vue?vue&type=template&id=d402de98"
import script from "./DetallesCliente.vue?vue&type=script&lang=js"
export * from "./DetallesCliente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__